// const CryptoJS = require("crypto-js");
import SHA512 from "crypto-js/sha512";
import Hex from "crypto-js/enc-hex";

const dist = (...args) => {
  // p5._validateParameters("dist", args);
  if (args.length === 4) {
    //2D
    return Math.hypot(args[2] - args[0], args[3] - args[1]);
  } else if (args.length === 6) {
    //3D
    return Math.hypot(args[3] - args[0], args[4] - args[1], args[5] - args[2]);
  }
};

const lerp = (start, stop, amt) => {
  // p5._validateParameters('lerp', arguments);
  return amt * (stop - start) + start;
};

const map = (n, start1, stop1, start2, stop2, withinBounds) => {
  // p5._validateParameters('map', arguments);
  const newval = ((n - start1) / (stop1 - start1)) * (stop2 - start2) + start2;
  if (!withinBounds) {
    return newval;
  }
  if (start2 < stop2) {
    return this.constrain(newval, start2, stop2);
  } else {
    return this.constrain(newval, stop2, start2);
  }
};

const round = (n, decimals) => {
  if (!decimals) {
    return Math.round(n);
  }
  const multiplier = Math.pow(10, decimals);
  return Math.round(n * multiplier) / multiplier;
};

export { dist, lerp, map, round };
